import cx from 'classnames'

import Typography from '@ui/Typography'

import * as styles from './MessageBubble.css'

interface MessageBubbleProps {
  message: string
  classes?: { [className in MessageBubbleClassNames]?: string }
}

const MessageBubble = ({ message, classes }: MessageBubbleProps) => {
  return (
    <div className={cx(styles.root, classes?.root)}>
      <div className={cx(styles.wrapper, classes?.wrapper)}>
        <div
          className={cx(styles.floatingBubbleContainer, classes?.floatingBubbleContainer)}
        >
          <div className={cx(styles.firstFloatingBubble, classes?.firstFloatingBubble)} />
          <div
            className={cx(styles.secondFloatingBubble, classes?.secondFloatingBubble)}
          />
        </div>
        {/*
         // @ts-expect-error Provide Typography with a component prop */}
        <Typography variant="footnote" color="textPrimary">
          {message}
        </Typography>
      </div>
    </div>
  )
}

export default MessageBubble

type MessageBubbleClassNames =
  | 'root'
  | 'wrapper'
  | 'floatingBubbleContainer'
  | 'firstFloatingBubble'
  | 'secondFloatingBubble'
